export interface ExistingMersDocumentForAdd {
  mersDocumentType: string | null;
  mersSignatureValue?: string | null;
  mersStatus?: string | null;
  name: string;
}

const ACTIVE_MERS_DUPLICATE_STATUSES = new Set(["MersPending", "MersLinked"]);

export function isMersAddDocumentDuplicate(
  existingMersDocuments: ExistingMersDocumentForAdd[],
  selectedType: string,
  computedHash: string,
  fileName: string
): boolean {
  return existingMersDocuments.some((document) => {
    if (document.mersDocumentType !== selectedType) {
      return false;
    }

    if (!ACTIVE_MERS_DUPLICATE_STATUSES.has(document.mersStatus ?? "")) {
      return false;
    }

    if (document.mersSignatureValue != null && document.mersSignatureValue === computedHash) {
      return true;
    }

    return document.name === fileName;
  });
}
